/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import { Container } from './tracking-queue-filters.style';
import Link from '../link';
import FilterField from '../filter-field';
import { MODE_TYPES } from '../../../../constants';
import { trackingTLQueueFilterDefs, trackingLTLQueueFilterDefs } from './tracking-queue-filter-defs';

/**
 * The tracking queue filters component
 * @param {object} props - Object containing the props for this component
 * @param {object} props.filterOptions - Dropdown options for all select fields
 * @param {object} props.activeFilters - Current active filters on data set
 * @param {func} props.handleUpdateFilters - Function to update filters
 * @param {func} props.handleClearFilters - Function to clear all filters
 * @return {element}
 */
const TrackingQueueFilters = ({
  filterOptions,
  activeFilters,
  handleUpdateFilters,
  handleClearFilters,
  mode,
}) => {
  const trackingQueueFilterDefs = mode === MODE_TYPES.truckload
    ? trackingTLQueueFilterDefs
    : trackingLTLQueueFilterDefs;
  // Build filter fields
  const filterFields = trackingQueueFilterDefs.map((filter, i) => (
    <FilterField
      key={i}
      type={filter.type}
      fieldId={filter.fieldId}
      label={filter.label}
      filterOptions={filter.type === 'select' ? filterOptions : undefined}
      activeFilters={activeFilters}
      handleUpdateFilters={handleUpdateFilters}
    />
  ));

  return (
    <Container data-testid="tracking-queue-filters">
      {filterFields}
      <Link onClick={handleClearFilters} text="Clear Column Filters" />
    </Container>
  );
};

TrackingQueueFilters.propTypes = {
  filterOptions: PropTypes.object,
  activeFilters: PropTypes.object,
  handleUpdateFilters: PropTypes.func.isRequired,
  handleClearFilters: PropTypes.func.isRequired,
  mode: PropTypes.string.isRequired,
};

TrackingQueueFilters.defaultProps = {
  filterOptions: null,
  activeFilters: null,
};

export default TrackingQueueFilters;
